module.exports = __webpack_public_path__ + "static/img/generic_12.2ea02bff.png";